"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PackagePicture = PackagePicture;
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _jsxRuntime = require("react/jsx-runtime");
const ImageWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  marginLeft: '4px',
  borderRadius: theme.shape.borderRadius
}));
function PackagePicture({
  url,
  alt
}) {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const theme = (0, _mui.useTheme)();
  const testId = getTestId('package-icon');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.CheckoutImage, {
    component: ImageWrapper,
    src: url ?? 'noImage',
    alt: alt ?? 'package',
    testId: testId,
    size: "small",
    background: theme.palette.grey[100],
    width: "38px",
    height: "38px"
  });
}
